import React from 'react';


class BildirimKutusu extends React.Component {

    constructor(){
        super();
    }

    render() {
        const { baslik, mesaj, ikon, buttonOnClick, className } = this.props;

        return (
            <div className={'m-alert m-alert--icon m-alert--outline alert alert-'
            +className+' alert-dismissible'} role="alert">
                <div className="m-alert__icon">
                    <i className={ikon ? ikon : "la la-warning"} />
                </div>
                <div className="m-alert__text">
                    {baslik ? <strong>{baslik} </strong> : null}
                    {mesaj}
                </div>
                <div className="m-alert__close">
                    { buttonOnClick ?
                        <button type="button"
                                onClick={buttonOnClick}
                                className="close" /> : null }
                </div>
            </div>
        );
    }

}

export default BildirimKutusu;